import React from "react";
import { myCustomTheme } from "../../Theme";

import {
    HiOutlineCubeTransparent,
    HiOutlineCube,
} from "react-icons/hi";

import { BsBoxSeam } from "react-icons/bs";

import featuresData from "../../Json/FeaturesData.json";

import "../../Style/FeaturesSection.css";

/* ICON MAP */

const iconMap = {
    HiOutlineCubeTransparent: <HiOutlineCubeTransparent />,
    BsBoxSeam: <BsBoxSeam />,
    HiOutlineCube: <HiOutlineCube />,
};
const theme = myCustomTheme;

const FeaturesSection = () => {
    return (
        <section className="features-section">

            <div className="container-fluid">

                <div className="container-1440">

                    {/* BOXES */}

                    <div className="features-box-wrapper">

                        {featuresData.map((item) => (

                            <div className="feature-box" key={item.id}>

                                {/* ICON */}

                                <div className="feature-icon">
                                    {iconMap[item.icon]}
                                </div>

                                {/* CONTENT */}

                                <div className="feature-content">

                                    <h3
                                        style={{
                                            fontFamily: theme.typography.heading_font,
                                        }}
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    ></h3>

                                    <p style={{
                                        fontFamily: theme.typography.text_font,
                                    }}>{item.desc}</p>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

            </div>

        </section>
    );
};

export default FeaturesSection;